{
  "title": "Reopen a Locked Score",
  "description": "Let a judge revise a score they've already locked and submitted.",
  "headings": [
    "What You'll Accomplish",
    "Applies to",
    "Before You Start",
    "Where to Go",
    "Steps",
    "What You'll See",
    "Warning",
    "FAQ"
  ],
  "summary": "Once finished, the score is unlocked for that judge on that submission, so they can revise and resubmit it.",
  "roleNote": "Competition admin with score.manage permission",
  "prerequisites": [
    "A judge has already submitted and locked a score for this submission",
    "You've confirmed the specific reason for reopening it"
  ],
  "pathLabel": "Organizer console → Submissions → Submission Details → Scores",
  "steps": [
    {
      "title": "1. Open the submission details",
      "description": "Find the submission in \"Submissions\" and open its \"Submission Details\" page."
    },
    {
      "title": "2. Find the locked score",
      "description": "In the scores section, find the judge's locked score."
    },
    {
      "title": "3. Click \"Reopen\"",
      "description": "Click \"Reopen\", fill in the required reason, and confirm."
    }
  ],
  "afterward": [
    "The score is unlocked",
    "The judge can revise and resubmit it",
    "An audit record and revision history are created"
  ],
  "warning": "Reopening does not overwrite the original score, but it creates a traceable revision history — confirm the reason before proceeding.",
  "nextSteps": "Once the judge resubmits, the score locks again; recalculate results afterward if needed.",
  "faq": [
    {
      "q": "Does reopening erase the original score?",
      "a": "No. The original score and its revision history stay in the audit record — reopening only lets the judge revise and submit a new score."
    }
  ]
}
